export default __webpack_public_path__ + "static/BT_Benefits_Carousel_01-a79c669bd7dd7535f722be3e45394fcd.jpg";